// extracted by mini-css-extract-plugin
module.exports = {"latestPhones":"phoneslider_latestPhones__8913T","phone":"phoneslider_phone__t5xew","title":"phoneslider_title__1FnY9"};